import { DataSourcePublic } from './types';

export function isPublicSource(source: string, publicDataSources: DataSourcePublic[] | undefined) {
  return publicDataSources ? publicDataSources.map(d => d.id).includes(source) : false;
}
